import React, { useState } from 'react';
import styled from 'styled-components';
import { navigate } from 'gatsby';

export default function VaudCta() {
  const [intervention, setIntervention] = useState('Ouverture de porte');
  const [phone, setPhone] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    const data = JSON.stringify({
      phone,
      intervention,
    });

    fetch('https://super-serrurier.vercel.app/api/canton_contact', {
      method: 'POST',
      body: data,
    })
      .then((response) => {
        if (response.status === 200) {
          navigate('/thank-you');
        } else {
          console.log('[!200]:', response);
        }
      })
      .catch((err) => console.error('[Error]: ', err));
  };
  return (
    <form className="hidden md:block" onSubmit={handleSubmit}>
      <div className="w-full flex flex-col justify-center items-center mt-6">
        <p className="text-base font-medium text-white w-auto">
          Devis instantané par téléphone
        </p>

        <div className="mt-3 sm:flex sm:justify-between sm:items-center">
          <div>
            <Select
              id="location"
              name="location"
              className="custom-select text-base border-gray-300 focus:outline-none focus:ring-primarycolor focus:border-primarycolor sm:text-sm rounded-md"
              onChange={(e) => setIntervention(e.target.value)}
              value={intervention}
            >
              <option value="Ouverture de porte">Ouverture de porte</option>
              <option value="Changement de serrure">
                Changement de serrure
              </option>
              <option value="Double de clés">Double de clés</option>
              <option value="Blindage de porte existante">
                Blindage de porte existante
              </option>
              <option value="Porte blindée">Porte blindée</option>
              <option value="Installation de porte de garage">
                Installation de porte de garage
              </option>
              <option value="Rideau métallique">Rideau métallique</option>
            </Select>
          </div>
          {/*
                <div className="w-full sm:w-4/5">
                  <input
                    id="email"
                    type="email"
                    name="email"
                    className="block w-full shadow-sm py-3 px-4 placeholder-gray-500 focus:ring-indigo-500 focus:border-indigo-500 border-gray-300 rounded-md"
                    placeholder="Email"
                  />
                </div>
                */}
          <div className="w-full sm:w-4/5 ml-2">
            <input
              required
              type="text"
              id="phone"
              name="phone"
              className="block w-full shadow-sm py-3 px-4 placeholder-gray-500 focus:ring-indigo-500 focus:border-indigo-500 border-gray-300 rounded-md"
              placeholder="Phone"
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
            />
          </div>

          <div className="ml-0 mt-3 md:ml-5 md:mt-0">
            <Button
              type="submit"
              className="border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-secondarycolor hover:bg-secondarycolor-light focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primarycolor custom-button"
            >
              Rappelez moi
            </Button>
          </div>
        </div>
      </div>
    </form>
  );
}

const Select = styled.select`
  padding-top: 0.9rem;
  padding-bottom: 0.9rem;
  padding-left: 1rem;
  padding-right: 2rem;
`;

const Button = styled.button`
  padding-top: 0.9rem;
  padding-bottom: 0.9rem;
  width: 170px;
`;
